import { render, staticRenderFns } from "./CreditCardCredentialsOnboarding.vue?vue&type=template&id=21835348&scoped=true&"
import script from "./CreditCardCredentialsOnboarding.vue?vue&type=script&lang=js&"
export * from "./CreditCardCredentialsOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./CreditCardCredentialsOnboarding.vue?vue&type=style&index=0&id=21835348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21835348",
  null
  
)

export default component.exports